import { cDadDataVisualizationMapData } from "assets/DataFile/headerPageData";
import { useStyles } from "pages/c-dad-datavisualization/style";
import { JobDetail } from "pages/c-dad-user-data";
import DataFilterMap from "shared-component/data-filter-map";


interface MapVisualizationProps {
    jobDetails: JobDetail[],
    expanded: string;
}

const MapVisualization = (props: MapVisualizationProps) => {
    const { jobDetails } = props;
    console.log('jobDetails', jobDetails)
    const style = useStyles();
  
    return (
        <>
            {false &&
                <div className={style.overlay}>
                    <div className={style.loader}></div>
                </div>}
            {true && <DataFilterMap data={cDadDataVisualizationMapData} />}
        </>
    )
};

export default MapVisualization;  